<template>
  <myhead @next="next" @lookmore="more">{{
    $route.query.title || $route.meta.title
  }}</myhead>
  <!-- <div class="search">
    <Search @click="handleSearch"></Search>
  </div> -->
  <div class="score-container">
    <div>
      <div class="accident-list size14">
        <div>
          <p class="accident-list-tle">
            {{ commentInfo.no }} {{ commentInfo.name }}
          </p>
          <div class="accident-list-t flex" v-if="!commentInfo.outcome">
            {{ commentInfo.judgment_nickname }}裁决结果:
            <div class="accident-list-hint">未结案，请等待裁决结果</div>
          </div>
          <div class="accident-list-t" v-else>
            {{ commentInfo.judgment_nickname }}裁决结果:
            <p v-html="commentInfo.outcome"></p>
          </div>
        </div>
        <div class="accident-b flex between center">
          <p>{{ commentInfo.add_time }}</p>
          <div class="accident-behavior flex center">
            <div class="flex center">
              <img src="@/assets/img/shop7.png" />
              <p>({{ commentInfo.comment_count }}+)</p>
            </div>
            <div class="flex center" @click="handleAccidentLike(commentInfo.id, 1)">
              <img src="@/assets/img/shop10.png" />
              <p>({{ commentInfo.bad_count }}+)</p>
            </div>
            <div class="flex center" @click="handleAccidentLike(commentInfo.id, 0)">
              <img src="@/assets/img/shop5.png" />
              <p>({{ commentInfo.good_count }}+)</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <p class="size16">评论({{ commentInfo.info.evaluate_count }}+)</p> -->
    <input type="text" class="score-container-input" placeholder="写点什么" @click="handleComment" ref="input" />
    <div class="score-list">
      <div class="score-list-con">
        <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="score-list-info" v-for="item in commentList" :key="item.id">
            <div class="flex between center">
              <div class="flex center">
                <img :src="item.head_pic" class="score-list-info__img" />
                <p class="score-list-info__name">{{ item.nickname }}</p>
              </div>
            </div>
            <p class="score-list-info__desc size14">{{ item.content }}</p>
            <div class="score-list-info-descimg flex"></div>
            <div class="flex between score-action">
              <div class="flex">
                <p class="score-list-info__time">{{ item.add_time }}</p>
                <p class="size12 score-list-info__txt" @click.stop="handleWakeupInput(item.id)">
                  回复
                </p>
              </div>
              <div class="flex" @click="handleLike(item.id, 0, item)">
                <img src="@/assets/img/shop11.png" />
                <p class="size14">({{ item.like_count }}+)</p>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
  <!-- <div style="position:fixed;bottom:0;left: 0;right: 0;" class="flex" > -->

  <div class="replybox flex between center" style="position: fixed; bottom: 0; left: 0; right: 0" v-show="replyShow">
    <textarea type="text" class="reply" ref="reply" :placeholder="toName" v-model="content"></textarea>
    <p @click="handleSubmit">发送</p>
  </div>
  <!-- <div class="flex between schedule-bottom">
    <router-link
      :to="{
        path: '/shop/accident/judgment',
        query: { order_id: $route.query.id },
      }"
      >判决文书</router-link
    >
    <router-link
      :to="{
        path: '/shop/accident/complaint',
        query: { order_id: commentInfo.order_id,type:'order' },
      }"
      >查看诉呈</router-link
    >
  </div> -->
  <!-- <button>发送</button> -->
  <!-- </div> -->
  <van-overlay :show="commentShow">
    <div class="wrapper">
      <div class="block">
        <img src="@/assets/img/icon32.png" class="closeimg" @click="hideCommentShow">
        <van-list v-model:loading="comloading" :finished="comfinished" finished-text="没有更多了" @load="oncomLoad">
          <div v-for="item in accidentCommentList" :key="item.user_id" class="flex commentShowList">
            <img :src="item.head_pic">
            <p class="commentShowList-nickname">{{ item.nickname }}</p>
            <p class="commentShowList-time">{{ item.add_time }}</p>
          </div>
        </van-list>
      </div>
    </div>
  </van-overlay>
</template>
  <script setup>
import ajax from "@/utils/request.js";
// import Search from "@/components/Search.vue";
import { ref } from "vue";
// import { useRoute, useRouter } from "vue-router";
import { useRoute } from "vue-router";
import { showToast } from "vant";
const { query } = useRoute();
// const { push } = useRouter();

const currentLike = ref()

const commentShow = ref(false)

const loading = ref(false)
const finished = ref(false)

const content = ref();
const input = ref();
const toName = ref("");
const reply = ref();
const replyShow = ref(false);

const commentInfo = ref({
  no: "",
  name: "",
  judgment_nickname: "",
  outcome: "",
  add_time: "",
  comment_count: "",
  bad_count: "",
  good_count: "",
  evaluate_count: "",
});
//获取事故详情，无评论列表
const getCommentInfo = () => {
  const data = {
    id: query.id,
    keyword: query.search || "",
  };
  return ajax.post("products/getaccidentinfo", data).then((res) => {
    commentInfo.value = res.data;
  });
};
//获取评论列表
const page = ref(1);
const commentList = ref([]);
const getCommentList = () => {
  loading.value = true
  const data = {
    id: commentInfo.value.id,
    parent_id: 0,
    page: page.value,
  };
  return ajax.post("products/commentlist", data).then((res) => {
    if (res.data.length < 10) {
      commentList.value = commentList.value.concat(res.data);
      finished.value = true
    } else {
      commentList.value = commentList.value.concat(res.data);
      page.value++
    }

  });
};
getCommentInfo().then(() => {
  getCommentList()
}).finally(() => {
  loading.value = false
})
//获取点赞点踩人员
const accidentCommentList = ref([])
const accidentCommentPage = ref(1)
const comloading = ref(false)
const comfinished = ref(false)
const getList = (type) => {
  comloading.value = true
  const data = {
    id: query.id,
    cate_id: 1,
    type: type,
    page: accidentCommentPage.value
  }
  ajax.post('/products/userlist', data).then(res => {
    if (res.data.length < 10) {
      accidentCommentList.value = accidentCommentList.value.concat(res.data)
      comfinished.value = true
    } else {
      accidentCommentList.value = accidentCommentList.value.concat(res.data)
      accidentCommentPage.value++
    }
  })
}
const oncomLoad = () => {
  getList(currentLike.value).finally(() => {
    comloading.value = false
  })
}
//评论
const handleComment = () => {
  console.log("click");
  replyShow.value = true;
  input.value.blur();
  setTimeout(() => {
    reply.value.focus();
  }, 0);
};

// const handleSearch = () => {
//   push({
//     path: "/shop/search",
//     query: { origin: window.location.pathname, ...query },
//   });
// };
//评论点赞
const handleLike = (id, is_like, item) => {
  const data = {
    id: query.goods_id,
    comment_id: id,
    typeid: is_like === 0 ? 1 : 2,
  };
  ajax.post("products/accidenthandle", data).then((res) => {
    if (res.errcode === 1) {
      showToast(res.message);
      item.like_count++;
      // commentInfo.value.good_count = Number(commentInfo.value.good_count) + 1
    }
  });
};
//事故点赞 0是点赞
const handleAccidentLike = (id, is_like) => {
  accidentCommentPage.value = 1
  accidentCommentList.value = []
  comfinished.value = false
  const data = {
    typeid: is_like === 0 ? 1 : 2,
    id: id,
  };
  ajax.post("products/accidenthandle", data).then((res) => {
    if (res.errcode === 1) {
      showToast(is_like == 0 ? '点赞成功' : '点踩成功');
      if (is_like == 0) {
        commentInfo.value.good_count++
        commentInfo.value.bad_count = commentInfo.value.bad_count > 0 ? --commentInfo.value.bad_count : 0
      } else {
        commentInfo.value.good_count = commentInfo.value.good_count > 0 ? --commentInfo.value.good_count : 0
        commentInfo.value.bad_count++
      }
    }
  }).then(() => {
    const like = is_like == 0 ? 1 : 0
    currentLike.value = like
    hideCommentShow()
    getList(like)
  })
};
//事故评论唤起输入框
const parentid = ref();
const isComment = ref(0);
const handleWakeupInput = (id) => {
  parentid.value = id;
  isComment.value === 1;
  replyShow.value = true;
  input.value.blur();
  setTimeout(() => {
    reply.value.focus();
  }, 0);
};
//事故评论回复
const handleCommentReply = () => {
  const data = {
    typeid: 3,
    id: commentInfo.value.id,
    parent_id: parentid.value,
    content: content.value,
  };
  return ajax.post("products/accidenthandle", data).then((res) => {
    console.log(res);
    if (res.errcode === 1) {
      isComment.value === 0;
    }
  });
};

//发送评论
const handleSubmit = () => {
  if (isComment.value === 1) {
    handleCommentReply().then(() => {
      page.value = 1;
      commentList.value = [];
      getCommentList();
    });
  } else {
    const data = {
      typeid: 3,
      content: content.value,
      id: commentInfo.value.id,
      parent_id: 0,
      // comment_id:commentInfo.value.id
    };
    ajax
      .post("products/accidenthandle", data)
      .then((res) => {
        if (res.errcode === 1) {
          showToast(res.message);
          content.value = "";
          getCommentInfo();
        }
      })
      .then(() => {
        page.value = 1;
        commentList.value = [];
        getCommentList();
      });
  }
};
//更新列表
const onLoad = () => {

}
const hideCommentShow = () => {
  commentShow.value = !commentShow.value
}
</script>
  <style lang="scss" scoped>
.search {
  padding: 0 4vw;
  margin-top: 1.6vw;
}
.score-container {
  padding: 5.3333vw 4vw 60px;
}
.score-container-input {
  background-color: #f6f6f6;
  width: 100%;
  height: 8.5333vw;
  border-radius: 4.2667vw;
  margin-top: 2.6667vw;
  padding: 0 4vw;
}
.score-list {
  .score-list-tle {
    margin-top: 5.3333vw;
  }
  .score-list-con {
    padding: 2px 3.2vw;
    margin-top: 2.6667vw;
    border-radius: 2.1333vw;
    .score-list-info {
      padding: 2.6667vw 0;
      .score-list-info__img {
        width: 6.4vw;
        height: 6.4vw;
        border-radius: 50%;
        margin-right: 1.0667vw;
        background-color: skyblue;
      }
      .score-list-info__name {
        font-size: 14px;
        color: #333333;
      }
      .score-list-info__time {
        font-size: 12px;
        color: #999999;
      }
      .score-list-children {
        padding-left: 7.4667vw;
        margin-top: 2.6667vw;
      }
      .score-list-info__txt {
        padding-left: 5.3333vw;
        color: #3f7c93;
        letter-spacing: 1px;
      }
    }
    .score-list-info__desc {
      color: #666666;
      margin-top: 3.2vw;
    }
    .score-list-info-descimg {
      margin-top: 2.6667vw;
      img {
        object-fit: cover;
        width: 21.3333vw;
        height: 21.3333vw;
        margin-right: 2.6667vw;
        &:nth-child(4) {
          margin-right: 0;
        }
      }
    }
  }
  .score-action {
    margin-top: 2.6667vw;
    img {
      width: 5.3333vw;
      height: 5.3333vw;
      margin-left: 4.8vw;
      margin-right: 2px;
    }
  }
}
.replybox {
  width: 100%;
  padding: 5px 4vw;
  box-shadow: 1px 0 3px #999999;
  border-radius: 2vw 2vw 0 0;
  z-index: 2;
  background-color: #fff;
}
.reply {
  width: 80%;
  box-sizing: border-box;
  background-color: #ffffff;
  border: 1px solid #f6f6f6;
}
.accident-list {
  background: #f6f6f6;
  padding: 1.6vw;
  border-radius: 2.1333vw;
  p {
    color: #666666;
  }
  .accident-list-tle {
    color: #999999;
    
  }
  .accident-list-t {
    margin-top: 2.6667vw;
    margin-bottom: 1.0667vw;
  }
  .accident-list-hint{
    padding-left: 10px;
    color: red;
    font-size: 16px;
    font-weight: bold;
  }
  .accident-b {
    margin-top: 5.3333vw;
    p {
      color: #999999;
    }
    .accident-behavior {
      img {
        display: block;
        width: 5.3333vw;
        margin-left: 2.6667vw;
        margin-right: 1.0667vw;
      }
    }
  }
}
.c3F7C93 {
  background-color: rgba(63, 124, 147, 0.2);
}
.schedule-bottom {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 15px;
  z-index: 999;
}
.schedule-bottom a {
    width: 48%;
    height: 10vw;
    line-height: 10vw;
    text-align: center;
    border-radius: 4vw;
    border: 1px solid #cccccc;
    font-size: 14px;
    color: #3f7c93;
    background-color: #fff;
}
.schedule-bottom a:last-child {
    background-color: #3f7c93;
    color: #ffffff;
}
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 90%;
    height: 300px;
    background: #FFFFFF;
    border-radius: 4.2667vw;
    padding: 10px 20px;
    position: relative;
  }
  .closeimg {
    position: absolute;
    width: 16px;
    height: 16px;
    position: absolute;
    top: 15px;
    right: 15px;
  }
  .commentShowList {
    padding: 10px 0;
    border-bottom: 1px solid #CCCCCC;
  }
  .commentShowList img {
    width: 42px;
    height: 42px;
    border-radius: 50%;
  }
  .commentShowList-nickname {
    width: 100px;
    font-size: 16px;
    color: #333333;
    margin-left: 10px;
    margin-right: 20px;
  }
  .commentShowList-time {
    font-size: 12px;
    color: #999999;
  }
</style>